import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onRate, size = 20, readOnly = false, testid }) => {
  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          onClick={() => onRate && onRate(n)}
          data-testid={testid ? `${testid}-star-${n}` : undefined}
          className={`transition-transform duration-150 ${
            readOnly ? "cursor-default" : "hover:scale-125 cursor-pointer"
          }`}
        >
          <Star
            style={{ width: size, height: size }}
            className={
              n <= value
                ? "fill-[#F5B841] text-[#F5B841]"
                : "text-white/25"
            }
          />
        </button>
      ))}
    </div>
  );
};
